export default "__VITE_PUBLIC_ASSET__0ada304d__"